module.exports = __webpack_public_path__ + "static/media/appcenter-forgotPassword.741c6352.svg";